// extracted by mini-css-extract-plugin
export var root = "Header-module--root--35hrx";
export var logo = "Header-module--logo--RPmCm";
export var content = "Header-module--content--3VQro";
export var title = "Header-module--title--2NCtK";
export var subtitle = "Header-module--subtitle--1lVoo";